module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"complete":{"msg":"Please check the email sent to the specified E-mail."},"mail":{"label":"E-mail"},"submit":"Send","error":{"IUM001":"This E-mail is already registered."}},"ja":{"complete":{"msg":"指定のメールアドレスにメールを送りましたので確認してください。"},"mail":{"label":"メールアドレス"},"submit":"送信する","error":{"IUM001":"このメールアドレスは使用されているため登録できません。"}}}')
  delete Component.options._Ctor
}
